<template>
<div   :class="[document ? '':'container-fluid']">

<!-- Modal -->
<div class="modal" id="categoryModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered  ">
    <div class="modal-content ">
      <div class="modal-header border-primary">
        
        <h4 class="modal-title" id="staticBackdropLabel"><strong>
           <i class="fas fa-edit   mr-2" aria-hidden="true"></i>
          MODIFICA CATEGORIA</strong>
          <p style="color:blue">{{categoryHeader}}</p>
          </h4>
          

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        
      </div>
      <div class="modal-body">
    
      <input v-focus type="text" class="form-control" placeholder="Nuova categoria" id="category" v-model="editCategory" required>
      <span style="color:red">{{err}}</span>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-secondary " data-dismiss="modal">ANNULLA</button>
        <button :disabled="!editCategory.length" @click="updateData()" type="button" class="btn btn-primary mr-4">
          <i class="fas fa-save mr-2" aria-hidden="true"></i>
          SALVA</button>
      </div>
    </div>
  </div>
</div>

<div class="card border-primary ">
    <div :class="[document ? 'bg-info':'bg-primary']" class="card-header text-white">  
      
        <h4>
           <i style="color:yellow" class="fas fa-swatchbook   mr-2" aria-hidden="true"></i>
          CLASSIFICAZIONE CATEGORIA
        </h4>
    </div>
    <div class="card-body"> 
   
       <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>  

       <div  class="table-wrapper-scroll-y my-custom-scrollbar mt-3 ml-4">
       <table  class="table table-hover table-sm mb-4" id="table">
        <thead >
        <tr>
          <th>LISTA CATEGORIE GRUPPO {{group}} </th>   
        </tr>
        </thead>
        <tbody >
        <tr data-toggle="tooltip" title="doppio click modifica categoria" :class="`index-${index}`" @dblclick="setModal(item)" v-for="(item, index)  in items" :key="index">
          <td>  
            
            {{item.category}}  
           
          </td> 
                    
        </tr>
        </tbody>
      </table>
    </div>

   <alert-box class="mt-4" @close="msg.title=''" v-bind:msg="msg"  ></alert-box> 

    <!--<strong>Filtra colore</strong> <input class="form-control" type="text"  v-model="filterKey">  -->
  
    
    </div>


 <div class="card-footer">
  <div v-if="add" class="mt-4">        
  <form v-on:submit.prevent="saveData()">
  <div class="form-row ml-4">  

    <div class="col-4">
      <input v-focus type="text" class="form-control" placeholder="Nuova categoria" v-model="category" required>
    </div>

    <div class="col">

      <button type="submit"  class="btn btn-primary mb-2">
         <i class="fas fa-save mr-2" aria-hidden="true"></i>
        SALVA</button>  
      <button type="button" @click="add=false" class="btn btn-outline-secondary mb-2 ml-3 ">ANNULLA</button>  
    </div>
        
  </div>
  </form>

  </div>
  <div v-else>
       <div class="row ml-4">
      
       
       <button  type="button" @click="setNew()" class="btn btn-primary ml-3" > <span v-if="spinner" class="spinner-grow spinner-grow-sm"></span>
       <i class="fas fa-plus-circle mr-2" aria-hidden="true"></i>
       NUOVA CATEGORIA</button>      
       </div>
  </div> 


  
  </div>

</div>
  


</div>    
</template>
<script>
import { mapGetters }    from 'vuex';
import categoryGrouping  from '@/components/common/CategoryGroupingSelect_1.vue'
import api               from '@/api'
import alertBox          from '@/components/common/AlertBox.vue'


export default {
   components: {categoryGrouping,alertBox},
  props: ['document'],
  data () {
    return {

       catGrouping    : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },
        spinner         : false,
        
        category        : '',
        items           : [],
        savedItems      : [],
        filterKey       : '',
        add             : false,
        parentId        : 0,
        msg             : {title : '',body:'',type :0},
        editCategory    : '',
        categoryHeader  : '',
        categoryId      : 0,
        err             : '',
        group           : ''
        
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },  
computed: 
  {
    ...mapGetters(['company']),
   
  },
mounted()
    {   
      
        
    },
created()
{
   this.getData()
},    
methods: 
{
    scrollToTop() 
    {
      
      let el = document.getElementById("table");
      el.scrollIntoView();

    },
    setNew()
    {
      this.msg.title = ''
      this.add       = true
      this.category  = ''
    },
    setModal(item)
    {
      this.categoryHeader = item.category
      this.msg.title = ''
      this.err = ''
      this.editCategory = item.category
      this.categoryId = item.categoryId
      $('#categoryModal').on('shown.bs.modal', function () {
        $('#category').trigger('focus')
      })
      $('#categoryModal').modal('show')
    },
    setGroupCategoryId(parentId,e)
    {
      if(e)
      {
        this.group = e.target.options[e.target.options.selectedIndex].text 
      }
      this.parentId = parentId
      let arr = this.savedItems.filter(item => item.parentId == parentId)
      this.items = arr
      this.scrollToTop()

      
      
    },

    reset()
    {
        this.msg = ''
    },

   
    async getData()
    {
        var data     = {'companyId':this.company.Id}
        var sp       = {'sp':'spCompanyCategory'}
        var json     = Object.assign(data, sp)

        await api.post(json).then(res => {
          if(res.status==200)
            {
              
              //this.items = res.data.recordsets[0]
              this.savedItems = res.data.recordsets[0]
              if(this.parentId)
              {
                this.setGroupCategoryId(this.parentId)
              }
              

                 
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                      
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                      
            } 
        }).catch(err => 
        {
          

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                      
          

        }).finally(() => {
          this.spinner = false
        });


        


    },
    
    updateData()
    {
        this.err = ''
         

        let isCategory = this.items.filter(item=> item.category.toUpperCase() == this.editCategory.toUpperCase() && this.categoryId != item.categoryId  )
        if(isCategory.length > 0)
        {
            this.err = "CATEGORIA GIA' ESISTENTE"
            
            return
        }
        $('#categoryModal').modal('hide')
       
        let data = {'categoryId':this.categoryId,'category':this.editCategory}
        let sp   = {'sp':'spUpdateCategory'}
        let json = Object.assign(data, sp)

        api.post(json).then(res => {
          if(res.status==200)
            {
                            
              this.msg.title = 'AGGIORNAMENTO CATEGORIA EFFETTUATO.'
              this.msg.body = ''
              this.msg.type = 0   
              this.getData()
                                             
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                      
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                      
            } 
        }).catch(err => 
        {
          

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                      
          

        }).finally(() => {
          this.spinner = false
        });
  


    },
    saveData()
    {
         
          this.msg.title = ''
          if(this.parentId==0)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body = 'GRUPPO CATEGORIA NON SELEZIONATO.'
            this.msg.type = 1                    

            return
          }
           
        let isCategory = this.items.filter(item=> item.category.toUpperCase() == this.category.toUpperCase())
        if(isCategory.length > 0)
        {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = "CATEGORIA GIA' ESISTENTE."
            this.msg.type = 1                    

            return
        }

        let data = {'companyId':this.company.Id,'category':this.category,'category_it':this.category,'parentId':this.parentId}
        let sp   = {'sp':'spCreateCategory'}
        let json = Object.assign(data, sp)

        api.post(json).then(res => {
          if(res.status==200)
            {
              this.add = false  
              this.msg.title = 'CREAZIONE CATEGORIA EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0   
              this.getData()
              

                 
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                      
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                      
            } 
        }).catch(err => 
        {
          

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                      
          

        }).finally(() => {
          this.spinner = false
        });
  


         /*this.spinner = true            
         var data     = []
         */

         
             
    }
}    
  
}
</script>

<style scoped>
.card-header
{
  height: 45px;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
 .my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }

  .table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;
    position     : sticky;
    top          : 0;
    z-index      : 10;
  

 }
 .table-hover:hover
{
  cursor: pointer;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}

</style>